import { inject } from '@angular/core'
import { ResolveFn, Router } from '@angular/router'
import { InitialConfigState } from './store/reducers/initial-config.reducer'
import { InitialConfigService } from './initial-config.service'
import { catchError } from 'rxjs/operators'
import { EMPTY, noop } from 'rxjs'
import { defaultAppConfig } from './app-config-default'

export const requireInitialConfigResolver: ResolveFn<InitialConfigState> = () => {
  const initialConfigService = inject(InitialConfigService)
  const router = inject(Router)
  return initialConfigService.getInitialConfiguration().pipe(
    catchError(() => {
      router
        .navigate(['/', defaultAppConfig.feedback.paths._root, defaultAppConfig.feedback.paths.genericError])
        .then(noop)
      return EMPTY
    }),
  )
}
